<script>
import {mapState, mapMutations} from "vuex";
import TriviaService from "@/api/services/triviaService";
import DcbService from "@/api/services/dcbService";

export default {
  name: 'PrizesView',
  data() {
    return {
      encryptedMsisdn: null
    }
  },
  computed: {
    ...mapState(['userStats', 'user', 'productId', 'isFreeUser']),
  },
  methods: {
    ...mapMutations(['setUserStats']),
    async getUserStats() {
      const recordsets = await TriviaService.getUserStats(this.user.msisdn, this.productId, this.user.serviceId);
      this.setUserStats(recordsets?.[0]?.[0])
    },
    async encryptMsisdn() {
      let encryptMsisdnResponse = (await DcbService.encryptUserMsisdn(this.user.msisdn)).data;
      this.encryptedMsisdn = encryptMsisdnResponse.encryptedMsisdn;
    },
    async viewCouponStore() {
      await this.encryptMsisdn();
      window.open(`https://voucher-store-staging.mzrhythm.com/?e-msisdn=${this.encryptedMsisdn}&productId=35`, '_self');
    },
    },
  async mounted(){
    await this.getUserStats();
  }
}
</script>

<template>
  <div class="d-flex flex-column justify-content-center align-items-center col-12">

    <div class="d-flex justify-content-between align-items-center col-11 mt-4 ">
      <img :src="isFreeUser ? require('@/assets/logos/logo-free.png') : require('@/assets/logos/logo-vip.png')"
           class="col-5" alt="logo"/>
      <div class="d-flex flex-column justify-content-center align-items-end col-5">
        <div class="d-flex justify-content-center align-items-center  col-5 gap-2">
          <div class="col-4 mt-2 mb-2 fw-bold coin-size-value">{{ userStats?.TotalCoins }}</div>
          <img src="@/assets/gameplay/coins-medium.png" class="col-8 mt-2 mb-2" alt="coins"/>
        </div>
      </div>
    </div>

    <div class="d-flex mt-4 p-3 justify-content-center yellow-button border col-11" @click="viewCouponStore">VIEW COUPON STORE</div>

    <div class="mt-3 prizes">Prizes</div>
    <div class="info-text blue ">Swipe through to learn how to play</div>
    <div class="info-text blue ">and win with Mzansi Rhythms</div>

    <img class="col-11 mt-2 " :src="isFreeUser ? require('@/assets/prizes/free_user.png') : require('@/assets/prizes/vip_user.png')"/>

  </div>

</template>

<style scoped>
.yellow-button{
  font-size: 18px;
  font-weight: 600;
  background: #FFCB05;
  border-radius: 43px;
}

.prizes{
  font-size: 22px;
  font-weight: 600;
}

.blue{
  color: #000F56;
}

.coin-size-value{
  font-size: 20px;
}

</style>